export function fromDollarsToCents(value: string | number): number {
    return Number((Number(value) * 100).toFixed());
}
